import { render } from "./Suppliers.vue?vue&type=template&id=093f6532&ts=true"
import script from "./Suppliers.vue?vue&type=script&lang=ts"
export * from "./Suppliers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__